import { MachuyentienService } from 'src/services/machuyentien.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const MACHUYENTIEN_NEW_CARE_SUCCESS = 'MACHUYENTIEN:NEW_CARE_SUCCESS'
export const MACHUYENTIEN_LIST_SUCCESS = 'MACHUYENTIEN:FIND_ALL_SUCCESS'
export const MACHUYENTIEN_LIST_FAILD = 'MACHUYENTIEN:FIND_ALL_FAILD'
export const MACHUYENTIEN_COUNT_ASSIGN_SUCCESS = 'MACHUYENTIEN:COUNT_ASSIGN_SUCCESS'
export const MACHUYENTIEN_COUNT_ASSIGN_FAILD = 'MACHUYENTIEN:COUNT_ASSIGN_FAILD'

export const MACHUYENTIEN_CREATE_SUCCESS = 'MACHUYENTIEN:CREATE_SUCCESS'
export const MACHUYENTIEN_CREATE_FAILD = 'MACHUYENTIEN:CREATE_FAILD'

export const MACHUYENTIEN_IMPORT_SUCCESS = 'MACHUYENTIEN:IMPORT_SUCCESS'
export const MACHUYENTIEN_SAVE_SUCCESS = 'MACHUYENTIEN:SAVE_SUCCESS'
export const MACHUYENTIEN_SAVE_FAILD = 'MACHUYENTIEN:SAVE_SUCCESS'

export const MACHUYENTIEN_DEL_SUCCESS = 'MACHUYENTIEN:DEL_SUCCESS'
export const MACHUYENTIEN_DEL_FAILD = 'MACHUYENTIEN:DEL_FAILD'

export const MACHUYENTIEN_ONE_SUCCESS = 'MACHUYENTIEN:FIND_ONE_SUCCESS'
export const MACHUYENTIEN_ONE_FAILD = 'MACHUYENTIEN:FIND_ONE_FAILD'

export const MACHUYENTIEN_HISTORY_LIST_SUCCESS = 'MACHUYENTIEN:HISTORY_FIND_ALL_SUCCESS'
export const MACHUYENTIEN_HISTORY_LIST_FAILD = 'MACHUYENTIEN:HISTORY_FIND_ALL_FAILD'

export const MACHUYENTIEN_UPDATE_FILTER = 'MACHUYENTIEN:UPDATE_FILTER'

export const MachuyentienAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,
}

function updateFilter(payload) {
    return { type: MACHUYENTIEN_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            MachuyentienService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(MachuyentienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: MACHUYENTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            MachuyentienService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(MachuyentienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: MACHUYENTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        MachuyentienService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MACHUYENTIEN_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { machuyentien } = getState()
        dispatch(AppAction.appLoading(true));
        MachuyentienService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...machuyentien.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MACHUYENTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { machuyentien } = getState();
        const page = machuyentien && typeof machuyentien.filter !== 'undefined' && machuyentien.filter && typeof machuyentien.filter.page !== 'undefined' ? machuyentien.filter.page : 0;
        const limit = machuyentien && typeof machuyentien.filter !== 'undefined' && machuyentien.filter && typeof machuyentien.filter.limit !== 'undefined' ? machuyentien.filter.limit : 10;
        MachuyentienService.findAll(page, limit, machuyentien.filter).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                const oldItems = machuyentien.items;
                const rsDataValues = rs.data.values;

                var uniqueItems = oldItems;
                for (var i = limit * page; i < limit * page + limit; i++) {
                    if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                        uniqueItems[i] = rsDataValues[i - limit * page];
                    } else if (typeof uniqueItems[i] !== 'undefined') {
                        delete uniqueItems[i];
                    }
                }
                
                dispatch(success({
                    items: uniqueItems,
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MACHUYENTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: MACHUYENTIEN_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            MachuyentienService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(MachuyentienAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: MACHUYENTIEN_SAVE_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            MachuyentienService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(MachuyentienAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: MACHUYENTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        MachuyentienService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(MachuyentienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MACHUYENTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        MachuyentienService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(MachuyentienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MACHUYENTIEN_DEL_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        MachuyentienService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MACHUYENTIEN_ONE_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        MachuyentienService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(MachuyentienAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { machuyentien } = getState()
        dispatch(AppAction.appLoading(true));
        MachuyentienService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...machuyentien.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MACHUYENTIEN_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: MACHUYENTIEN_HISTORY_LIST_FAILD, error } }
}